import { RetryLink } from '@apollo/client/link/retry';

export const getRetryLink = () =>
    new RetryLink({
        attempts: {
            max: 5,
            retryIf: (error, operation) =>
                !operation.getContext()?.noRetry &&
                !!error &&
                ![400, 410].includes(error.statusCode as number),
        },
    });
